module.exports = __webpack_public_path__ + "img/safe.0e03e74b.svg";